import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from 'vue-i18n';

import VueCollapse from "vue2-collapse";
import axios from 'axios'
import  "amfe-flexible";

Vue.use(VueI18n);
Vue.use(VueCollapse);
Vue.config.productionTip = false;
Vue.prototype.$http = axios
const i18n=new VueI18n({
  silentTranslationWarn: true,
  locale:localStorage.getItem('languageFirecat')||'en',   //从localStorage里获取用户中英文选择，没有则默认中文
  messages:{
    'zh':require('./components/language/zh'),
    'en':require('./components/language/en'),
  }
})

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
